import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { GrupoEspecieFrEditComponent } from './gruposespeciesfr/grupoespeciefr-edit.component';
import { GrupoEspecieFrListComponent } from './gruposespeciesfr/grupoespeciefr-list.component';
import { GrupoEspecieFrExEditComponent } from './gruposespeciesfrex/grupoespeciefrex-edit.component';
import { GrupoEspecieFrExListComponent } from './gruposespeciesfrex/grupoespeciefrex-list.component';
import { GrupoPaisFrEditComponent } from './grupospaisesfr/grupopaisfr-edit.component';
import { GrupoPaisFrListComponent } from './grupospaisesfr/grupopaisfr-list.component';
import { GrupoTaricFrEditComponent } from './grupostaricfr/grupotaricfr-edit.component';
import { GrupoTaricFrListComponent } from './grupostaricfr/grupotaricfr-list.component';
import { GrupoTaricFrExEditComponent } from './grupostaricfrex/grupotaricfrex-edit.component';
import { GrupoTaricFrExListComponent } from './grupostaricfrex/grupotaricfrex-list.component';
import { PaisFrEditComponent } from './paisesfr/paisfr-edit.component';
import { PaisFrListComponent } from './paisesfr/paisfr-list.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { GrupoTaricFrSanidadExteriorListComponent } from './grupostaricfrsanidadexterior/grupotaricfrsanidadexterior-list.component';
import { GrupoTaricFrSanidadExteriorEditComponent } from './grupostaricfrsanidadexterior/grupotaricfrsanidadexterior-edit.component';

const frecuenciareducidaRoutes: Routes = [
    //PAíSES FR
    {
        path: 'mantenimiento/frecuenciareducida/paisesfr',
        data: {
            breadcrumb: 'Países FR',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: PaisFrListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: PaisFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar País de Grupo Países FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: PaisFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo País de Grupo Países FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS PAíSES FR
    {
        path: 'mantenimiento/frecuenciareducida/grupospaisesfr',
        data: {
            breadcrumb: 'Grupos Países FR',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: GrupoPaisFrListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: GrupoPaisFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Grupo Países FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: GrupoPaisFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo Países FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS TARIC FR
    {
        path: 'mantenimiento/frecuenciareducida/grupostaricfr',
        data: {
            breadcrumb: 'Grupos Taric FR',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: GrupoTaricFrListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: GrupoTaricFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Grupo Taric FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: GrupoTaricFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo Taric FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS TARIC FR Higiene
    {
        path: 'mantenimiento/frecuenciareducida/grupostaricfrsanidadexterior',
        data: {
            breadcrumb: 'Grupos Taric FR Higiene',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: GrupoTaricFrSanidadExteriorListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: GrupoTaricFrSanidadExteriorEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Grupo Taric FR Higiene',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: GrupoTaricFrSanidadExteriorEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo Taric FR Higiene',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS ESPECIES FR
    {
        path: 'mantenimiento/frecuenciareducida/gruposespeciesfr',
        data: {
            breadcrumb: 'Grupos Especies FR',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: GrupoEspecieFrListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: GrupoEspecieFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Grupo Especie FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: GrupoEspecieFrEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo Especie FR',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS TARIC FR EXPORTACIÓN
    {
        path: 'mantenimiento/frecuenciareducida/grupostaricfrex',
        data: {
            breadcrumb: 'Gr. Taric FR EX',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: GrupoTaricFrExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: GrupoTaricFrExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Grupo Taric FR Ex',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: GrupoTaricFrExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo Taric FR EX',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS ESPECIES FR EXPORTACIÓN
    {
        path: 'mantenimiento/frecuenciareducida/gruposespeciesfrex',
        data: {
            breadcrumb: 'Gr. Especies FR EX',
            menu0: 'MANTENIMIENTO',
            menu1: 'Frecuencia Reducida',
        },
        children: [
            {
                path: '',
                component: GrupoEspecieFrExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: GrupoEspecieFrExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Grupo Especie FR EX',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: GrupoEspecieFrExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo Especie FR EX',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(frecuenciareducidaRoutes)],
    exports: [RouterModule],
})
export class FrecuenciareducidaRoutingModule {}
